import simboloCartivia from '../../assets/images/cartivia-simbolo.svg'
import wordmarkCartivia from '../../assets/images/cartivia-wordmark.png'
import { LogoWrapper, Simbolo, Tagline, Wordmark } from './LogoCartivia.style'

type LogoCartiviaProps = {
  /** Empilha simbolo, wordmark e tagline — usado nas telas de autenticacao. */
  vertical?: boolean
  /** Esconde o wordmark; usado na sidebar colapsada. */
  somenteSimbolo?: boolean
  /** Exibe a assinatura "A inteligencia da sua carteira ativa". */
  comTagline?: boolean
  /** Tamanho base em px — o conjunto inteiro escala a partir dele. */
  tamanho?: number
}

/**
 * Logo Cartivia. O simbolo e vetorial (SVG) e o wordmark e um PNG recortado do
 * manual da marca — a fonte do wordmark (Mundial) e comercial e nao esta
 * disponivel como webfont, entao o desenho original e preservado como imagem.
 *
 * As duas pecas sao desenhadas em branco/verde, para fundo escuro.
 */
export function LogoCartivia({
  vertical = false,
  somenteSimbolo = false,
  comTagline = false,
  tamanho = 22,
}: LogoCartiviaProps) {
  return (
    <LogoWrapper $vertical={vertical} $tamanho={tamanho}>
      <Simbolo
        src={simboloCartivia}
        alt={somenteSimbolo ? 'Cartivia' : ''}
        width={186}
        height={187}
        $vertical={vertical}
      />
      {!somenteSimbolo && (
        <Wordmark
          src={wordmarkCartivia}
          alt="Cartivia"
          width={731}
          height={151}
        />
      )}
      {comTagline && !somenteSimbolo && (
        <Tagline>
          A inteligência da sua <strong>carteira ativa</strong>
        </Tagline>
      )}
    </LogoWrapper>
  )
}
